import React from "react";

export const CanvasScaleContext = React.createContext(1);
export const CanvasMoveModeContext = React.createContext(false);

export default CanvasScaleContext;
